import { render, staticRenderFns } from "./PresentationRoot.vue?vue&type=template&id=1731f3e2"
import script from "./PresentationRoot.vue?vue&type=script&lang=ts"
export * from "./PresentationRoot.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports